/**
 * 大事指标折线图验证配置
 * 为新 ValidationEngine 提供验证规则
 */

import type { ValidationConfig } from '../../../core/dataProcessor/types';

// 🆕 为新 ValidationEngine 导出的配置
export const markerLineValidationConfig: ValidationConfig = {
  fields: [
    { field: 'x', type: ['string', 'date'], required: true },
    { field: 'y', type: 'number', required: true },
    { field: 'y2', type: 'string', required: false },
    { field: 'subTitle', type: 'string', required: false },
    { field: 'desc', type: 'string', required: false },
    { field: 'link', type: 'string', required: false }
  ],
  businessRules: [
    {
      name: 'marker-line-unique-x-values',
      validator: (data, layer) => {
        if (!Array.isArray(data)) {
          return true;
        }
        const { encoding } = layer;
        const xValues = new Set(
          data.map((item: Record<string, unknown>) => item[encoding?.x as string])
        );
        return xValues.size >= 2;
      },
      message: 'Marker line requires at least 2 different x values',
      suggestion: 'Provide multiple time points for trend visualization',
      // 推荐性建议，不影响图表渲染
      severity: 'warning'
    },
    {
      name: 'marker-line-has-markers',
      validator: (data, layer) => {
        if (!Array.isArray(data)) {
          return true;
        }
        const { encoding } = layer;
        return data.some((item: Record<string, unknown>) => item[encoding?.y2 as string] != null);
      },
      message: 'Marker line requires at least one data point with a marker (y2 value)',
      suggestion: 'Add marker descriptions to highlight important events',
      // 推荐性建议，不影响图表渲染
      severity: 'warning'
    }
  ]
};
